/**
 * mirrorAnswerStream — the browser half of Mirror Mode's answer-token
 * streaming (M1, Lane 1103; amendment docs/audits/2026-08-27_chat-analyst_
 * MIRROR-MODE_plan-amendment.md §5 M1 item 5).
 *
 * The Mirror path streams the model's answer text live through the existing
 * /api/ai-assistant/stream transport as two new event types:
 *
 *   {type: "answer_delta", text: "..."}  incremental answer text, as written
 *   {type: "answer_reset"}               the streamed text belonged to a
 *                                        NON-final message (the model went
 *                                        back to querying); clear the draft
 *
 * Dedicated module by design (docs/critical-rules.md: Home.js composes the
 * experience but does not own new Chat Analyst runtime logic). This is a pure
 * reducer over (draftText, event); Home.js keeps the state and renders it.
 *
 * The draft is a live preview only. The authoritative answer is ALWAYS the
 * final payload's `answer` — a partial stream is never presented as a
 * completed answer (amendment §6), so the caller must discard the draft when
 * the turn ends, success or failure.
 */

/**
 * @param {string|null} draft current streamed draft (null = none)
 * @param {Object} event one stream event
 * @returns {string|null} next draft state
 */
export function mirrorStreamReduce(draft, event) {
  if (!event || typeof event.type !== 'string') return draft;
  if (event.type === 'answer_delta' && typeof event.text === 'string' && event.text) {
    return (draft || '') + event.text;
  }
  if (event.type === 'answer_reset') return null;
  return draft;
}
